/* Racemore dealer page (Plus Soap) */
(function () {
  if (window.RMDealer) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  document.documentElement.classList.add('rm-js');

  function $all(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  /* scroll loop shared by everything that tracks scroll */
  var scrollers = [];
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      scrollers = scrollers.filter(function (f) { return f() !== false; });
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  function track(fn) { scrollers.push(fn); fn(); }

  /* reveal on view */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); if (e.target._rmIn) e.target._rmIn(); }
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 }) : null;
  function reveal(el, cb) {
    if (cb) el._rmIn = cb;
    if (!io || reduce) { el.classList.add('is-in'); if (cb) cb(); return; }
    io.observe(el);
  }

  /* count up numbers */
  function countUp(el) {
    var to = parseFloat(el.dataset.to);
    if (isNaN(to)) return;
    var dec = (el.dataset.to.split('.')[1] || '').length;
    if (reduce) { el.textContent = to.toFixed(dec); return; }
    var t0 = null, dur = 1400;
    function step(t) {
      if (!t0) t0 = t;
      var k = clamp((t - t0) / dur, 0, 1);
      k = 1 - Math.pow(1 - k, 3);
      el.textContent = (to * k).toFixed(dec);
      if (k < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* pointer spotlight + tilt + magnetic buttons */
  function spotlight(root) {
    if (!fine) return;
    $all(root, '.rm-spot').forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--mx', (e.clientX - r.left) + 'px');
        el.style.setProperty('--my', (e.clientY - r.top) + 'px');
        if (el.hasAttribute('data-tilt') && !reduce) {
          var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
          el.style.setProperty('--ry', (x * 6).toFixed(2) + 'deg');
          el.style.setProperty('--rx', (-y * 6).toFixed(2) + 'deg');
        }
      });
      el.addEventListener('pointerleave', function () { el.style.setProperty('--rx', '0deg'); el.style.setProperty('--ry', '0deg'); });
    });
    if (reduce) return;
    $all(root, '.rm-btn[data-magnet]').forEach(function (b) {
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        b.style.setProperty('--bx', ((e.clientX - r.left - r.width / 2) * 0.18).toFixed(1) + 'px');
        b.style.setProperty('--by', ((e.clientY - r.top - r.height / 2) * 0.3).toFixed(1) + 'px');
      });
      b.addEventListener('pointerleave', function () { b.style.setProperty('--bx', '0px'); b.style.setProperty('--by', '0px'); });
    });
  }

  /* model buttons prefill the form */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-rm-model]');
    if (!a) return;
    var model = a.getAttribute('data-rm-model');
    var mode = a.getAttribute('data-rm-mode') || 'quote';
    document.querySelectorAll('.rm-form').forEach(function (f) {
      if (f._rmSet) f._rmSet(mode, model);
    });
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#rm-"], a[data-rm-mode]');
    if (!a || a.hasAttribute('data-rm-model')) return;
    var mode = a.getAttribute('data-rm-mode');
    if (mode) document.querySelectorAll('.rm-form').forEach(function (f) { if (f._rmSet) f._rmSet(mode); });
  });

  var inits = {
    nav: function (el) {
      var links = $all(el, '.rm-nav__links a[href^="#"]');
      var bar = el.querySelector('.rm-nav__progress');
      var main = el.closest('main') || document.body;
      track(function () {
        if (!el.isConnected) return false;
        var y = window.scrollY + 120;
        var cur = null;
        links.forEach(function (a) {
          var t = document.getElementById(a.getAttribute('href').slice(1));
          if (t && t.getBoundingClientRect().top + window.scrollY <= y) cur = a;
        });
        links.forEach(function (a) { a.classList.toggle('is-active', a === cur); });
        if (!cur) { var ul0 = el.querySelector('.rm-nav__links'); if (ul0 && ul0.scrollLeft) ul0.scrollLeft = 0; }
        if (cur && cur.scrollIntoView && cur.parentNode.parentNode.scrollWidth > cur.parentNode.parentNode.clientWidth) {
          var ul = cur.parentNode.parentNode;
          var left = cur.offsetLeft - ul.clientWidth / 2 + cur.clientWidth / 2;
          if (Math.abs(ul.scrollLeft - left) > 8) ul.scrollLeft = left;
        }
        if (bar) {
          var top = main.getBoundingClientRect().top + window.scrollY;
          var h = main.scrollHeight - window.innerHeight;
          bar.style.setProperty('--p', clamp((window.scrollY - top) / Math.max(h, 1), 0, 1).toFixed(4));
        }
      });
    },
    hero: function (el) {
      reveal(el);
      var media = el.querySelector('.rm-hero__media');
      var v = el.querySelector('video');
      if (v) {
        v.muted = true;
        var p = v.play && v.play();
        if (p && p.catch) p.catch(function () {});
      }
      if (reduce || !media) return;
      track(function () {
        if (!el.isConnected) return false;
        var r = el.getBoundingClientRect();
        if (r.bottom < 0) return;
        var k = clamp(-r.top / Math.max(r.height, 1), 0, 1);
        media.style.setProperty('--hs', (1.06 + k * 0.12).toFixed(4));
      });
    },
    intro: function (el) {
      $all(el, '.rm-stat__n [data-to]').forEach(function (n) { reveal(n.closest('.rm-stat'), function () { countUp(n); }); });
      var st = el.querySelector('.rm-intro__statement');
      if (!st) return;
      var words = $all(st, '.w');
      if (reduce) { words.forEach(function (w) { w.classList.add('on'); }); return; }
      track(function () {
        if (!el.isConnected) return false;
        var r = st.getBoundingClientRect();
        var k = clamp((window.innerHeight * 0.85 - r.top) / (r.height + window.innerHeight * 0.35), 0, 1);
        var n = Math.round(k * words.length);
        words.forEach(function (w, i) { w.classList.toggle('on', i < n); });
      });
    },
    story: function (el) {
      var panels = $all(el, '.rm-story__panel');
      var slides = $all(el, '.rm-story__slide');
      var bars = $all(el, '.rm-story__bars i');
      var count = el.querySelector('.rm-story__count b');
      var cur = -1;
      function set(i) {
        if (i === cur) return;
        cur = i;
        panels.forEach(function (p, j) { p.classList.toggle('is-on', j === i); });
        slides.forEach(function (s, j) {
          s.classList.toggle('is-on', j === i);
          var v = s.querySelector('video');
          if (v) { if (j === i) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } else v.pause(); }
        });
        bars.forEach(function (b, j) { b.classList.toggle('is-on', j === i); });
        if (count) count.textContent = String(i + 1).padStart(2, '0');
      }
      set(0);
      track(function () {
        if (!el.isConnected) return false;
        var mid = window.innerHeight * 0.5, best = 0, bd = Infinity;
        panels.forEach(function (p, j) {
          var r = p.getBoundingClientRect();
          var d = Math.abs(r.top + r.height / 2 - mid);
          if (d < bd) { bd = d; best = j; }
        });
        set(best);
      });
    },
    models: function (el) { spotlight(el); },
    uses: function (el) { spotlight(el); },
    fit: function (el) {
      var mm = { 27: [parseFloat(el.dataset.w27) || 1525, parseFloat(el.dataset.l) || 1780], 32: [parseFloat(el.dataset.w32) || 1600, parseFloat(el.dataset.l) || 1780] };
      var hmm = parseFloat(el.dataset.h) || 1400;
      var unit = 'ft', screen = '27';
      var ins = { w: el.querySelector('[name="rm-w"]'), l: el.querySelector('[name="rm-l"]'), c: el.querySelector('[name="rm-c"]'), x: el.querySelector('[name="rm-x"]') };
      var outs = { w: el.querySelector('[data-o="w"]'), l: el.querySelector('[data-o="l"]'), c: el.querySelector('[data-o="c"]'), x: el.querySelector('[data-o="x"]') };
      var svg = el.querySelector('.rm-fit__svg');
      var room = svg.querySelector('.room'), clr = svg.querySelector('.clear'), sim = svg.querySelector('.sim'), seat = svg.querySelector('.seat'), scr = svg.querySelector('.screen');
      var tw = svg.querySelector('.tw'), tl = svg.querySelector('.tl');
      var vb = el.querySelector('.rm-fit__verdict b'), vs = el.querySelector('.rm-fit__verdict div span');
      var specs = { w: el.querySelector('[data-s="w"]'), l: el.querySelector('[data-s="l"]'), h: el.querySelector('[data-s="h"]') };
      function fmtIn(inch) {
        if (unit === 'm') return (inch * 0.0254).toFixed(2) + ' m';
        var f = Math.floor(inch / 12), i = Math.round(inch - f * 12);
        if (i === 12) { f++; i = 0; }
        return f + '′ ' + i + '″';
      }
      function mmIn(v) { return v / 25.4; }
      function fill(r) { var p = (r.value - r.min) / (r.max - r.min) * 100; r.style.setProperty('--fill', p + '%'); }
      function draw() {
        var W = +ins.w.value, L = +ins.l.value, C = +ins.c.value, X = +ins.x.value; // inches
        var sw = mmIn(mm[screen][0]), sl = mmIn(mm[screen][1]), sh = mmIn(hmm);
        outs.w.textContent = fmtIn(W); outs.l.textContent = fmtIn(L); outs.c.textContent = fmtIn(C);
        outs.x.textContent = unit === 'm' ? (X * 2.54).toFixed(0) + ' cm' : X + '″';
        Object.keys(ins).forEach(function (k) { fill(ins[k]); });
        specs.w.textContent = fmtIn(sw); specs.l.textContent = fmtIn(sl); specs.h.textContent = fmtIn(sh);
        var needW = sw + X * 2, needL = sl + X * 2;
        var spareW = W - needW, spareL = L - needL, spareH = C - sh;
        var fitsBare = W >= sw && L >= sl && C >= sh;
        var state = (spareW >= 0 && spareL >= 0 && spareH >= 6) ? 'ok' : (fitsBare ? 'tight' : 'no');
        el.classList.toggle('is-tight', state === 'tight');
        el.classList.toggle('is-no', state === 'no');
        if (state === 'ok') { vb.textContent = el.dataset.ok; vs.textContent = fmtIn(Math.min(spareW, spareL)) + ' ' + el.dataset.spare; }
        else if (state === 'tight') { vb.textContent = el.dataset.tight; vs.textContent = el.dataset.tightSub; }
        else { vb.textContent = el.dataset.no; vs.textContent = C < sh ? el.dataset.noH : el.dataset.noSub; }
        // drawing: 400 x 300 box
        var pad = 28, bw = 400 - pad * 2, bh = 300 - pad * 2;
        var s = Math.min(bw / Math.max(W, needW), bh / Math.max(L, needL));
        var rw = W * s, rl = L * s, ox = (400 - rw) / 2, oy = (300 - rl) / 2;
        set(room, ox, oy, rw, rl);
        var cw = needW * s, cl = needL * s, cx = 200 - cw / 2, cy = 150 - cl / 2;
        set(clr, cx, cy, cw, cl);
        var smw = sw * s, sml = sl * s, smx = 200 - smw / 2, smy = 150 - sml / 2;
        set(sim, smx, smy, smw, sml);
        set(scr, smx + smw * 0.06, smy + sml * 0.05, smw * 0.88, Math.max(sml * 0.07, 3));
        set(seat, smx + smw * 0.3, smy + sml * 0.5, smw * 0.4, sml * 0.38);
        tw.setAttribute('x', 200); tw.setAttribute('y', Math.max(oy - 9, 12)); tw.textContent = fmtIn(W);
        tl.setAttribute('x', Math.max(ox - 10, 12)); tl.setAttribute('y', 150); tl.textContent = fmtIn(L);
        tl.setAttribute('transform', 'rotate(-90 ' + Math.max(ox - 10, 12) + ' 150)');
      }
      function set(r, x, y, w, h) { r.setAttribute('x', x.toFixed(1)); r.setAttribute('y', y.toFixed(1)); r.setAttribute('width', Math.max(w, 0).toFixed(1)); r.setAttribute('height', Math.max(h, 0).toFixed(1)); }
      Object.keys(ins).forEach(function (k) { ins[k].addEventListener('input', draw); });
      $all(el, '[data-unit]').forEach(function (b) {
        b.addEventListener('click', function () {
          unit = b.dataset.unit;
          $all(el, '[data-unit]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          draw();
        });
      });
      $all(el, '[data-screen]').forEach(function (b) {
        b.addEventListener('click', function () {
          screen = b.dataset.screen;
          $all(el, '[data-screen]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          draw();
        });
      });
      draw();
    },
    process: function (el) {
      var list = el.querySelector('.rm-steps');
      var rail = el.querySelector('.rm-steps__rail i');
      var steps = $all(el, '.rm-step');
      if (reduce) { steps.forEach(function (s) { s.classList.add('is-on'); }); if (rail) rail.style.setProperty('--p', 1); return; }
      track(function () {
        if (!el.isConnected) return false;
        var r = list.getBoundingClientRect();
        var k = clamp((window.innerHeight * 0.7 - r.top) / Math.max(r.height + window.innerHeight * 0.1, 1), 0, 1);
        if (window.innerWidth >= 990) k = clamp((window.innerHeight * 0.8 - r.top) / (window.innerHeight * 0.5), 0, 1);
        if (rail) rail.style.setProperty('--p', k.toFixed(4));
        steps.forEach(function (s, i) { s.classList.toggle('is-on', k >= (i / Math.max(steps.length - 1, 1)) - 0.001 && k > 0.02); });
      });
    },
    form: function (el) {
      var tabs = $all(el, '.rm-tab');
      var kind = el.querySelector('[name="contact[Inquiry]"]');
      var model = el.querySelector('select[name="contact[Model]"]');
      function show(mode) {
        tabs.forEach(function (t) { var on = t.dataset.mode === mode; t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; });
        if (kind) kind.value = (tabs.filter(function (t) { return t.dataset.mode === mode; })[0] || {}).textContent || mode;
        $all(el, '[data-for]').forEach(function (f) {
          var on = f.getAttribute('data-for').split(' ').indexOf(mode) > -1;
          f.hidden = !on;
          $all(f, 'input, select, textarea').forEach(function (i) { i.disabled = !on; });
        });
        var head = el.querySelector('[data-rm-title]');
        var t = tabs.filter(function (x) { return x.dataset.mode === mode; })[0];
        if (head && t && t.dataset.title) head.textContent = t.dataset.title;
      }
      el._rmSet = function (mode, m) {
        if (mode) show(mode);
        if (m && model) {
          var opt = $all(model, 'option').filter(function (o) { return o.value === m; })[0];
          if (opt) model.value = m;
        }
      };
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { show(t.dataset.mode); });
        t.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          n.focus(); show(n.dataset.mode);
        });
      });
      var date = el.querySelector('input[type="date"]');
      if (date) { var d = new Date(); d.setDate(d.getDate() + 1); date.min = d.toISOString().slice(0, 10); }
      show((tabs[0] || {}).dataset ? tabs[0].dataset.mode : 'demo');
      var hash = (location.hash || '').toLowerCase();
      if (hash.indexOf('quote') > -1) show('quote');
    },
    faq: function () {}
  };

  function initAll(root) {
    $all(root || document, '[data-rm]').forEach(function (el) {
      if (el._rmDone) return;
      el._rmDone = true;
      var f = inits[el.getAttribute('data-rm')];
      if (f) f(el);
      $all(el, '.rm-reveal').forEach(function (r) { reveal(r); });
    });
  }
  window.RMDealer = { init: initAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); onScroll(); });
})();
